import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { IUserTaskResult, TStatus } from '../../../types/tasks/tasksTypes'
import { apiTasksService } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'
import { TaskKeys } from '../../store/user/userReducer'

interface IUpdateUserTaskResultProps {
    code: TaskKeys
    userTaskId: string
    status: TStatus
    result?: IUserTaskResult
}

const updateUserTaskResult =
    ({ code, userTaskId, status, result }: IUpdateUserTaskResultProps) =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<void> => {
        const { userData } = getState()
        const params = {
            userId: userData.smsAuth.userId,
            userTaskId,
            status,
            result,
            uid: userData.smsAuth.userId,
        }
        const config = {
            headers: {
                Authorization: `${anchor} ${localStorage.getItem('accessToken')}`,
            },
        }
        try {
            const { data } = await apiTasksService.post(
                '/updateUserTaskResult',
                params,
                config,
            )
            if (data) {
                dispatch({
                    type: storeDispatchTypes.setAccountTaskInfo,
                    value: {
                        code,
                        task: data,
                    },
                })
            }
        } catch (e) {
            console.error('update userTask result failed', e)
            throw e
        }
    }

export default updateUserTaskResult
